import { Sun, Moon } from "lucide-react";
import { usePrefs } from "../lib/prefs";

export const PrefToggles = () => {
  const { lang, setLang, theme, setTheme, t } = usePrefs();
  return (
    <div className="flex items-center gap-2">
      <div className="flex rounded-full border border-violet-400/30 p-0.5 font-mono text-[11px] sm:text-xs" data-testid="lang-toggle">
        {[["ms", "BM"], ["en", "EN"]].map(([k, l]) => (
          <button
            key={k}
            onClick={() => setLang(k)}
            data-testid={`lang-${k}-btn`}
            aria-pressed={lang === k}
            className={`px-2.5 py-1.5 rounded-full transition-colors duration-300 ${lang === k ? "bg-violet-500 text-white keep-white" : "text-violet-200"}`}
          >
            {l}
          </button>
        ))}
      </div>
      <button
        onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
        data-testid="theme-toggle-btn"
        aria-label={theme === "dark" ? t.themeLight : t.themeDark}
        title={theme === "dark" ? t.themeLight : t.themeDark}
        className="w-9 h-9 rounded-full border border-violet-400/30 grid place-items-center text-violet-200 hover:bg-violet-500/15 transition-colors duration-300"
      >
        {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
      </button>
    </div>
  );
};
